export const downloadFileByUrl = async (url: string): Promise<void> => {
  const a = document.createElement('a');
  const blob = await fetch(url).then((r) => r.blob());
  const data = URL.createObjectURL(blob);

  a.href = data;
  a.download = url.slice(url.lastIndexOf('/') + 1);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
